export const USERDATA = 'USERDATA'
export const USERTOKEN = 'USERTOKEN'
export const COMPANY_ID = 'COMPANY_ID'
export const USERNAME = 'USERNAME'
export const MENU = 'MENU'
export const ID = 'ID'
